import {DatePipe} from "@angular/common";
import {provideHttpClient, withInterceptors, withInterceptorsFromDi} from "@angular/common/http";
import {ApplicationConfig, provideZonelessChangeDetection} from "@angular/core";
import {MAT_MOMENT_DATE_FORMATS} from "@angular/material-moment-adapter";
import {MAT_DATE_FORMATS} from "@angular/material/core";
import {MatDatepickerIntl} from "@angular/material/datepicker";
import {MatPaginatorIntl} from "@angular/material/paginator";
import {provideRouter} from "@angular/router";
import {provideCharts, withDefaultRegisterables} from "ng2-charts";
import {provideIcons} from "./app.config.icons";
import {provideSecurity} from "./app.config.security";
import {provideTranslate} from "./app.config.translate";
import {routes} from "./app.routes";
import {errorInterceptor} from "./services/error/error-interceptor";
import {DatepickerInternationalization} from "./services/translate/datepicker-internationalization";
import {PaginatorInternationalization} from "./services/translate/paginator-internationalization";
import {MAT_DIALOG_DEFAULT_OPTIONS} from "@angular/material/dialog";

export const appConfig: ApplicationConfig = {
    providers: [
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: {
                restoreFocus: false,
                autoFocus: false
            }
        },
        {provide: MatPaginatorIntl, useClass: PaginatorInternationalization},
        {provide: MatDatepickerIntl, useClass: DatepickerInternationalization},
        provideZonelessChangeDetection(),
        provideRouter(routes),
        provideHttpClient(withInterceptorsFromDi(), withInterceptors([errorInterceptor])),
        provideCharts(withDefaultRegisterables()),
        {provide: DatePipe},
        provideTranslate(),
        provideIcons(),
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                ...MAT_MOMENT_DATE_FORMATS,
                display: {
                    ...MAT_MOMENT_DATE_FORMATS.display,
                    dateInput: "[KW] w (DD.MM.YYYY)",
                    monthYearLabel: "MMM YYYY",
                    dateA11yLabel: "LL",
                    monthYearA11yLabel: "MMMM YYYY",
                },
                parse: {
                    ...MAT_MOMENT_DATE_FORMATS.parse,
                    dateInput: "L",
                },
            },
        },
        provideSecurity(),
    ],
};
